<template>
    <tbody>
    <tr v-if="data.length" v-for="(row, rowIndex) in data" :id="getRowId(rowIndex)" v-bind:style="getTrStyleObject(rowIndex)">
        <template v-for="(column, columnIndex) in columns" v-if="isShow(column.field)">
            <template v-if="column.visible">
                <template v-if="(isFieldShowDatesComparison(column.field) && datesComparisonEnabled)">
                    <td v-bind:class="column.field" v-bind:style="{'min-width': column.width}">
                        <div>
                            {{getFieldValue(row, column.field, (column.isMetricValue + column.isCompareColumn), getDateAIndex(row.node.metrics)) | format(column.format)}}
                        </div>
                    </td>
                    <td v-bind:class="column.field" v-bind:style="{'min-width': column.width}">
                        <div>
                            {{getFieldValue(row, column.field, (column.isMetricValue + column.isCompareColumn), getDateBIndex(row.node.metrics)) | format(column.format)}}
                        </div>
                    </td>
                    <template v-if="!column.isCompareColumn">
                        <td v-bind:class="column.field" v-bind:style="{'min-width': column.width}">
                            <div>
                                {{getChangeValueBetweenDates(row.node.metrics, column.field) | formatCustom('integer')}}
                            </div>
                        </td>
                        <td v-bind:class="column.field" v-bind:style="{'min-width': column.width}">
                            <div>
                                {{getChangePercentageValueBetweenDates(row.node.metrics, column.field) | formatCustom('percentage', 2, '%')}}
                            </div>
                        </td>
                    </template>
                </template>

                <template v-else>
                    <td v-bind:class="column.field" v-bind:style="{'min-width': column.width}">
                        {{getFieldValue(row, column.field, (column.isMetricValue + column.isCompareColumn)) | format(column.format)}}
                    </td>
                </template>
            </template>

        </template>
    </tr>

    <tr v-if="reportSummaryData.length" v-for="(row, rowIndex) in reportSummaryData" :id="getRowId(rowIndex)" v-bind:style="getTrStyleObject(rowIndex)" class="tr-summary">
        <template v-for="(column, columnIndex) in columns" v-if="isShow(column.field)">
            <template v-if="column.visible">
                <template v-if="(isFieldShowDatesComparison(column.field) && datesComparisonEnabled)">
                    <td class="summary-totals-td" v-bind:class="column.field" v-bind:style="{'min-width': column.width}" :rowspan="(isSummaryFieldsEquals(row, column.field, (column.isMetricValue), 0) ? 2 : 1)">
                        <div>
                            <template v-if="column.isMetricValue">
                                {{getFieldValue(row, column.field, (column.isMetricValue + column.isCompareColumn), getDateAIndex(row.node.totals), 'totals') | format(column.format)}}
                            </template>
                        </div>
                    </td>
                    <td class="summary-totals-td" v-bind:class="column.field" v-bind:style="{'min-width': column.width}" :rowspan="(isSummaryFieldsEquals(row, column.field, (column.isMetricValue), 0) ? 2 : 1)">
                        <div>
                            <template v-if="column.isMetricValue">
                                {{getFieldValue(row, column.field, (column.isMetricValue + column.isCompareColumn), getDateBIndex(row.node.totals), 'totals') | format(column.format)}}
                            </template>
                        </div>
                    </td>
                    <template v-if="!column.isCompareColumn">
                        <td class="summary-totals-td" v-bind:class="column.field" v-bind:style="{'min-width': column.width}" :rowspan="(isSummaryFieldsEquals(row, column.field, (column.isMetricValue), 0) ? 2 : 1)">
                            <div>
                                <template v-if="column.isMetricValue">
                                    {{getChangeValueBetweenDates(row.node.totals, column.field) | formatCustom('integer')}}
                                </template>
                            </div>
                        </td>
                        <td class="summary-totals-td" v-bind:class="column.field" v-bind:style="{'min-width': column.width}" :rowspan="(isSummaryFieldsEquals(row, column.field, (column.isMetricValue), 0) ? 2 : 1)">
                            <div>
                                <template v-if="column.isMetricValue">
                                    {{getChangePercentageValueBetweenDates(row.node.totals, column.field) | formatCustom('percentage', 2, '%')}}
                                </template>
                            </div>
                        </td>
                    </template>
                </template>

                <template v-else>
                    <td class="summary-totals-td"
                            v-bind:class="column.field"
                            v-bind:style="{'min-width': column.width}"
                            :rowspan="(isSummaryFieldsEquals(row, column.field, (column.isMetricValue), 0) ? 2 : 1)"
                    >
                        <template v-if="column.isMetricValue">
                            {{getFieldValue(row, column.field, (column.isMetricValue + column.isCompareColumn), 0, 'totals') | format(column.format)}}
                        </template>
                    </td>
                </template>
            </template>

        </template>
    </tr>


    <tr v-if="reportSummaryData.length" v-for="(row, rowIndex) in reportSummaryData" :id="getRowId(rowIndex)" v-bind:style="getTrStyleObject(rowIndex)" class="tr-summary">
        <template v-for="(column, columnIndex) in columns" v-if="isShow(column.field)">
            <template v-if="column.visible && !isSummaryFieldsEquals(row, column.field, (column.isMetricValue), 0)">
                <template v-if="(isFieldShowDatesComparison(column.field) && datesComparisonEnabled)">
                    <td class="summary-averages-td" v-bind:class="column.field" v-bind:style="{'min-width': column.width}">
                        <div>
                            <template v-if="column.isMetricValue">
                                {{getFieldValue(row, column.field, (column.isMetricValue + column.isCompareColumn), getDateAIndex(row.node.averages), 'averages') | format(column.format)}}
                            </template>
                        </div>
                    </td>
                    <td class="summary-averages-td" v-bind:class="column.field" v-bind:style="{'min-width': column.width}">
                        <div>
                            <template v-if="column.isMetricValue">
                                {{getFieldValue(row, column.field, (column.isMetricValue + column.isCompareColumn), getDateBIndex(row.node.averages), 'averages') | format(column.format)}}
                            </template>
                        </div>
                    </td>
                    <template v-if="!column.isCompareColumn">
                        <td class="summary-averages-td" v-bind:class="column.field" v-bind:style="{'min-width': column.width}">
                            <div>
                                <template v-if="column.isMetricValue">
                                    {{getChangeValueBetweenDates(row.node.averages, column.field) | formatCustom('integer')}}
                                </template>
                            </div>
                        </td>
                        <td class="summary-averages-td" v-bind:class="column.field" v-bind:style="{'min-width': column.width}">
                            <div>
                                <template v-if="column.isMetricValue">
                                    {{getChangePercentageValueBetweenDates(row.node.averages, column.field) | formatCustom('percentage', 2, '%')}}
                                </template>
                            </div>
                        </td>
                    </template>
                </template>

                <template v-else>
                    <td class="summary-averages-td" v-bind:class="column.field" v-bind:style="{'min-width': column.width}">
                        <template v-if="column.isMetricValue">
                            {{getFieldValue(row, column.field, (column.isMetricValue + column.isCompareColumn), 0, 'averages') | format(column.format)}}
                        </template>
                    </td>
                </template>
            </template>

        </template>
    </tr>

    </tbody>
</template>

<script>
    import '@/style/reports/base_table_style.scss';

    import moment from 'moment';
    import tableColumnViewMixin from '@/components/reports/mixins/tableColumnViewMixin';
    import filterMixin from '@/components/mixins/filterMixin';
    import fixTableMixin from '@/components/reports/mixins/fixTableMixin';
    import datesComparisonTableMixin from '@/components/reports/mixins/datesComparisonTableMixin';
    import sortTableMixin from '@/components/reports/mixins/sortTableMixin';
    import {dateFormatDefault} from "@/helpers/format";

    export default {
        name: "customTableTBodyTemplate",
        components: {

        },
        props: {
            data: {
                type: Array,
                required: true
            },
            reportSummaryData: {
                type: Array,
                required: false
            },
            columns: {
                type: Array,
                required: true
            },
            namespace: {
                type: String,
                required: true
            },
            hoveredColumns: {
                type: Object,
                required: false
            },
            defaultColumns: {
                type: Array,
                required: true
            },
            fixed: {
                type: Boolean,
                default: false,
                required: false
            },
        },
        mixins: [
            tableColumnViewMixin,
            filterMixin,
            fixTableMixin,
            datesComparisonTableMixin,
            sortTableMixin
        ],
        data(){
            return {
            }
        },
        computed: {
        },
        filters: {

        },
        methods: {
            getRowId: function(rowIndex){
                if (this.fixed)
                {
                    return this.namespace + 'FixedRowColumn' + rowIndex;
                }
                else
                {
                    return this.namespace + 'RowColumn' + rowIndex;
                }
            },
            getRowIdOppositeTable: function(rowIndex){
                if (this.fixed)
                {
                    return this.namespace + 'RowColumn' + rowIndex;
                }
                else
                {
                    return this.namespace + 'FixedRowColumn' + rowIndex;
                }
            },
            isShow: function(columnName){
                let condition = (this.isColumnFixed(columnName) && this.isAnyFixedColumnsExist);

                if (this.fixed)
                {
                    return condition;
                }
                else
                {
                    return !condition;
                }
            },
            getFieldValue: function (dataRow, columnName, isMetric, rangeIndex = 0, groupType = 'metrics') {
                let data = dataRow.node;
                let value;

                const columnNames = {
                    hour: 'hour',
                    week: 'week',
                    year: 'year',
                    quarter: 'quarter',
                    month: 'month',
                    date: 'date',
                };

                let dateFormat = dateFormatDefault();

                if (!isMetric && groupType !== 'metrics')
                    return '-';

                if (isMetric && rangeIndex !== null) {
                    value = data[groupType][rangeIndex] !== undefined && data[groupType][rangeIndex][columnName] !== undefined ? data[groupType][rangeIndex][columnName] : null;
                }
                else {
                    value = data[columnName] !== undefined ? data[columnName] : null;
                }


                if (value !== null) {
                    switch (columnName) {
                        case columnNames.hour:
                            if (value === null)
                                break;

                            let value2 = value + 1;
                            value = value < 10 ? '0' + value : value;
                            value2 = value2 < 10 ? '0' + value2 : value2;
                            value = value + ':00 - ' + value2 + ':00';
                            break;
                        case columnNames.week:
                            if (data[groupType][rangeIndex] !== undefined && data[groupType][rangeIndex][columnNames.year] !== undefined) {
                                let year = data[groupType][rangeIndex][columnNames.year] !== undefined ? data[groupType][rangeIndex][columnNames.year] : null;
                                if (year === null) break;

                                let dateA = moment().day("Monday").year(year).week(value);
                                let dateB = moment().day("Monday").year(year).week(value).add(6, 'days');

                                value = dateA.format(dateFormat) + ' - ' + dateB.format(dateFormat);
                            }
                            break;
                        case columnNames.quarter:
                            if (data[groupType][rangeIndex] !== undefined && data[groupType][rangeIndex][columnNames.year] !== undefined) {
                                let year = data[groupType][rangeIndex][columnNames.year] !== undefined ? data[groupType][rangeIndex][columnNames.year] : null;
                                if (year === null) break;

                                let dateA = moment([year, 0, 1]).quarter(value);
                                let dateB = moment([year, 0, 1]).quarter(value).add(1, 'quarters').add(-1, 'days');

                                value = dateA.format(dateFormat) + ' - ' + dateB.format(dateFormat);
                            }
                            break;
                        case columnNames.month:
                            let date = moment().month(value);

                            value = date.format('MMMM');
                            break;
                        case columnNames.date:
                            value = moment(value, "YYYY-MM-DD").format(dateFormat);
                            break;
                    }

                    if(columnName === "partnerNames" && value.length) {
                        value = value.join(", ");
                    }
                }

                return value;
            },
            isSummaryFieldsEquals: function(dataRow, columnName, isMetric, rangeIndex) {
                if (!isMetric)
                    return false;

                return this.getFieldValue(dataRow, columnName, isMetric, rangeIndex, 'averages') === this.getFieldValue(dataRow, columnName, isMetric, rangeIndex, 'totals');
            },
            closeDropDownMenu: function(index){
                this.$set(this.showLinkDropDownMenu, index, false);
            },
            getTrStyleObject: function(rowIndex)
            {
                let styleObj = {};

                let rowRef = document.querySelector('#' + this.getRowIdOppositeTable(rowIndex));

                if (rowRef != undefined)
                {
                    styleObj.height = rowRef.offsetHeight + 'px';
                }

                return styleObj;
            },
            getColumnClasses(columnName, rowIndex){
                return {
                    //'hovered': this.isColumnHovered(columnName),
                    //'alter': (this.isColumnHovered(columnName) && rowIndex % 2 === 0),
                    //'hidden': (this.isColumnFixed(columnName) && this.isAnyFixedColumnsExist)
                    //'hovered': this.hoveredColumns[columnName]
                };
            },
        }
    }
</script>

<style lang="scss" scoped>
    tbody > tr {
        text-align: left;

        &:hover {
            background: #f5f5f5;
        }

        & > * {
            font-size: 13px;
        }

        & > td {
            border-right: 1px solid #f3f3f3;
            padding: 5px;
        }

        & > td.hovered {
            background: #f5f5f5;

            &.alter{
                background: #eef1f4;
            }
        }

        & > td.hidden {
            display: none;
        }

        & > td:last-child {
            border: 0;
        }
    }
</style>

<style lang="scss" scoped>
    .table-field__link {
        text-decoration: none;
        color: #0051ff;
        display: flex;
        align-items: center;

        &:hover {
            text-decoration: underline;
        }

        .arrow-drop-down {
            text-decoration: none;
            display: inline-block;
            width: 1.5em;
            height: 1.5em;
            color: #fff;
            background-image: url('/static/img/icon-arrow-drop-down-blue.svg');
            background-repeat: no-repeat;
            background-position: center;
            flex-shrink: 0;
        }
    }

    tbody > tr {
        text-align: left;

        &:hover {
            background: #f5f5f5;
        }

        & > * {
            font-size: 13px;
        }

        & > td {
            border-right: 1px solid #f3f3f3;
            padding: 5px;
        }

        & > td.hovered {
            background: #f5f5f5;

            &.alter{
                background: #eef1f4;
            }
        }

        & > td.hidden {
            display: none;
        }

        & > td:last-child {
            border: 0;
        }
    }

    tbody > tr.tr-summary {
        font-weight: bolder;
        background-color: #f3f3f3;;
    }

    .table > tbody > tr > td.summary-averages-td:nth-child(1):before {
        content: 'Average: ';
    }

    div.fixed-active table > tbody > tr > td.summary-averages-td:nth-child(1):before {
        content: inherit;
    }

    .table > tbody > tr > td.summary-totals-td:nth-child(1):before {
        content: 'Total: ';
    }

    div.fixed-active table > tbody > tr > td.summary-totals-td:nth-child(1):before {
        content: inherit;
    }

    .sticky-body-column {
        position: relative;
        display: table-cell;
        transition: 0.3s;
    }

    .sticky-body-column:nth-last-child {
        border-right: 3px solid #cecece;
    }
</style>



// WEBPACK FOOTER //
// src/components/reports/hourlyPartnersReport/templates/customTableTBodyTemplate.vue